import React, { Component } from 'react'
import FileList from './filelist';
import { bindActionCreators } from 'redux';
import { fetchStatus } from '../api/dlaapifunctions'
import { connect } from "react-redux";
import { setCache } from '../actions/gCache';
import { updateHistoryData } from '../actions/dlaactions'
import appconfig from '../../config/oAuthConfig';

import {

    LoadingScreen
} from '@nike/ruxac';
import moment from 'moment';

class RecentImportsTable extends Component {

    constructor(props) {
        super(props);
        this.collapseExpandClass = "btn-space toggle-accordion";

        this.state = {
            collapsAll: undefined,
            selectType: "All",
            historyDataLoaded: false

        }
        this.handleChange = this.handleChange.bind(this);
    }

    async componentWillMount() {
        let statusData =""
        try{
            statusData = await fetchStatus("user=" + this.props.auth.email.toLowerCase()+"&appName="+appconfig.loaderType);
         
         this.props.updateHistoryData(statusData.data.message);
        }catch(error){
            console.log("error in retriving status table......",error)
          
        }
        this.setState({
            historyDataLoaded: true
        })  
    }


    toggleCollapseExpand() {
        
        if (this.collapseExpandClass === "btn-space toggle-accordion active") {
            this.collapseExpandClass = "btn-space toggle-accordion";
        }
        else if (this.collapseExpandClass === "btn-space toggle-accordion") {
            this.collapseExpandClass = "btn-space toggle-accordion active";
        }

        this.setState({
            collapsAll: !this.state.collapsAll
        })


    }


    groupByDate(xs, key) {
        return xs.reduce(function (rv, x) {

            var date1 = moment(new Date(JSON.parse(x[key]))).format('L');

            (rv[date1] = rv[date1] || []).push(x);
            return rv;
        }, {});
    };


    handleChange(event) {
        this.setState({
            selectType: event.target.value
        })
    }



    render() {

        let historyData = this.props.historyData;

        if (this.state.selectType !== "All") {
            historyData = historyData.filter(
                historyData => historyData.fileType === this.state.selectType
            )

        }
        var groubedByDate = "";
        groubedByDate = this.groupByDate(historyData, 'timestamp');

        let rowid = -1;
        let filestatusdetails = ""

        const fileListByDate = Object.keys(groubedByDate).map(resultDate => {
            let finalData = groubedByDate[resultDate];
            rowid = rowid + 1;
            let recentItemData = {
                "resultDate": resultDate,
                "rowid": rowid

            }
            filestatusdetails = <FileList key={resultDate} groubedByDateData={finalData} recentItemData={recentItemData} collapsAll={this.state.collapsAll} />
            return filestatusdetails;

        })

        return (
            !this.state.historyDataLoaded ? (<LoadingScreen
                isLoading={true}
                loadingMessage='Loading...' />) : (
                    <div>
                        <div className="card-header">
                            Recent Imports
                            <div onClick={() => this.toggleCollapseExpand()} className={this.collapseExpandClass}>
                            </div>

                        </div>

                        {fileListByDate}


                    </div>
                )
        )



    }

}
const mapStateToProps = state => ({
    data: state.gCache.data,
    historyData: state.dlareducer.historyData,
    tempData: state.dlareducer.tempData,
    auth: state.auth




});
const mapDispatchToProps = dispatch => bindActionCreators({
    setCache,
    updateHistoryData
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps

)((RecentImportsTable));

